import { Component, Input } from "@angular/core"
import { PremiumSectionItem } from "../../../models/collection/premiumSectionItem.model"
import { WindowSizeService } from "../../../services/window-size.service"
import Utils from "../../../utils/utils"

@Component({
    selector: "app-overlay-collection-card",
    templateUrl: "./overlay-collection-card.component.html",
    styleUrls: ["./overlay-collection-card.component.scss"],
    standalone: false,
})
export class OverlayCollectionCardComponent {
    public premiumSectionItem: PremiumSectionItem
    public imageURL: string
    public imageAlt: string = "Open"
    @Input() public sectionName: string = ""

    constructor(public windowSize: WindowSizeService) {}

    get subCollectionLink() {
        return Utils.isPreviewMode()
            ? this.premiumSectionItem.url + "/preview/"
            : this.premiumSectionItem.url
    }

    @Input()
    public set item(value: PremiumSectionItem) {
        this.premiumSectionItem = value
        this.imageURL = value.image.resize(397 * 2, 168 * 2)
        this.imageAlt = value.imageAlt ? value.imageAlt : this.imageAlt
    }
}
